import { useMemo } from 'react';
import * as React from 'react';

import {
  BlogPostCard,
  UseCaseCard,
  UseCaseCategoryCard
} from './CardComponentType';
import {
  type RecommendationTypes,
  type RecommendedBlogPost,
  type RecommendedUseCase,
  type RecommendedUseCaseCategory
} from './Recommendations';

interface RecommendationCardProps {
  item: RecommendationTypes;
}

export const RecommendationCard: React.ComponentType<RecommendationCardProps> =
  React.memo(({ item }) => {
    const CardComponent = useMemo(() => {
      switch (item.__typename) {
        case 'ContentfulUseCase':
          return <UseCaseCard item={item as RecommendedUseCase} />;
        case 'ContentfulBlogPost':
          return <BlogPostCard item={item as RecommendedBlogPost} />;
        case 'ContentfulUseCaseCategory':
          return (
            <UseCaseCategoryCard item={item as RecommendedUseCaseCategory} />
          );
        default:
          return <></>;
      }
    }, [item]);

    return CardComponent;
  });
